import { Plus } from 'lucide-react';
import React from 'react';
import { Button, Tooltip, FormDrawer } from '../../ui';
import FormService from '../Forms/FormService';

export default function AddServices(props: { handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        props.handleFunction()
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Ajouter un nouveau service">
                <Button
                    size='sm'
                    className="float-right"
                    variant="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => setOpen(true)}
                >Ajouter</Button>
            </Tooltip>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Ajout d'un nouveau service"
                hint="Renseignez les informations du service à créer."
            >
                <FormService />
            </FormDrawer>
        </div>
    );
}
